import { css, keyframes } from "@emotion/react"
import { theme } from "@/theme"

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
`

const SkeletonCard = () => (
    <div
        css={css`
            display: grid;
            gap: 10px;
            padding: 16px;
            background-color: white;
            border: 1px solid ${theme.palette.gray[300]};
            border-radius: 12px;
        `}
    >
        {[60, 90, 40].map(width => (
            <div
                key={width}
                css={css`
                    width: ${width}%;
                    height: 14px;
                    background-color: ${theme.palette.gray[200]};
                    border-radius: 4px;
                `}
            />
        ))}
    </div>
)

/** 履歴の読み込み中プレースホルダ */
export const TransportationExpenseListSkeleton = () => (
    <div
        aria-busy
        css={css`
            display: grid;
            gap: 12px;
            animation: ${pulse} 1.4s ease-in-out infinite;
        `}
    >
        <SkeletonCard />
        <SkeletonCard />
    </div>
)
